import * as React from 'react';

import type { CareerRolesCollectionType } from 'bundles/unified-common/hooks/useCareerRolesCollection';

type Props = {
  content?: CareerRolesCollectionType;
};

export const CareerAcademyModuleRenderer = ({ content }: Props) => {
  // TODO: the rendering logic will be implemented in https://coursera.atlassian.net/browse/MERCH-627
  return (
    <div>
      {content?.entities?.map((role) => {
        return <div key={role.id}>{role.name}</div>;
      })}
    </div>
  );
};

export default CareerAcademyModuleRenderer;
